import { defineMessages } from 'react-intl';

export const messages: {
	understoodAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	understoodAction: {
		id: 'oauth-banner.acknowledgement.success-flag-action',
		defaultMessage: 'Understood',
		description:
			'Acknowledgement button label inside the post-connect success notification (flag/toast). Clicking the button dismisses the notification.',
	},
});
